require('../modules/es6.symbol');
require('../modules/es6.object.to-string');
module.exports = require('../modules/_core').Symbol;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/es6/symbol.js
// module id = 126
// module chunks = 0 3